import React from "react"
import { Form, DatePicker } from "antd"

export default function ReportMonthEnd({ required = true }) {
    return (
        <div>
            <Form.List name="form_data">
                {(fields) => (
                    <Form.Item label="Month End" name="month_end" rules={[{ required: required }]}>
                        <DatePicker style={{ width: "100%" }} />
                    </Form.Item>
                )}
            </Form.List>
        </div>
    )
}
